import {createAction} from 'redux-actions';
import axios from 'axios';
import {apiUrl} from './config';

export const LOADING = 'LOADING'
export const GET_USER = 'GET_USER';
export const WITHDRAW_USER = 'WITHDRAW_USER';
export const TAG_LIST = 'TAG_LIST';
export const TAG_CREATE = 'TAG_CREATE';
export const TAG_UPDATE = 'TAG_UPDATE';
export const TAG_DELETE = 'TAG_DELETE';
export const TAG_AMOUNT = 'TAG_AMOUNT';

export const APPLICATION_LIST = 'APPLICATION_LIST';
export const APPLICATION_DELETE = 'APPLICATION_DELETE';

export const TRANSACTION_LIST = 'TRANSACTION_LIST';
export const APP_AUTHORIZED_LOG_CREATE = 'APP_AUTHORIZED_LOG_CREATE';

export const setLoading = createAction(LOADING, (status) => {
  return status
});

export const getUser = createAction(GET_USER, (data) => {
  return axios.get(apiUrl + 'client/user')
    .then(function(res) {
      return res.data.data
    })
});

export const withdrawUser = createAction(WITHDRAW_USER, () => {
  return axios.delete(apiUrl + 'client/user')
    .then(function(res) {
      return res.data.data
    })
});

export const tags = createAction(TAG_LIST, (data) => {
  return axios.get(apiUrl + 'client/tags', data)
    .then(function(res) {
      return res.data.data
    })
});

export const addTag = createAction(TAG_CREATE, (data) => {
  return axios.post(apiUrl + 'client/tags', data)
    .then(function(res) {
      return res.data.data
    })
});

export const editTag = createAction(TAG_UPDATE, (data) => {
  return axios.put(apiUrl + 'client/tags/' + data.tag.id, data)
    .then(function(res) {
      return res.data.data
    })
});

export const deleteTag = createAction(TAG_DELETE, (id) => {
  return axios.delete(apiUrl + 'client/tags/' + id)
    .then(function(res) {
      return res.data.data
    })
});

export const amountTags = createAction(TAG_AMOUNT, () => {
  return axios.get(apiUrl + 'client/tags/get_amount')
    .then(function(res) {
        return res.data.data
    })
});

export const transactions = createAction(TRANSACTION_LIST, (data) => {
  return axios.get(apiUrl + 'client/transactions', {params: data})
    .then(function(res) {
      return res.data.data
    })
});

// support email
export const SUPPORT_EMAIL_CREATE = 'SUPPORT_EMAIL_CREATE';
export const SUPPORT_EMAIL_TYPES = 'SUPPORT_EMAIL_TYPES';

export const supportEmailCreate = createAction(SUPPORT_EMAIL_CREATE, (data) => {
  return axios.post(apiUrl + 'client/support_emails', data)
    .then(function(res) {
      return res.data.data
    })
});
export const supportEmailTypes = createAction(SUPPORT_EMAIL_TYPES, () => {
  return axios.get(apiUrl + 'client/support_emails')
    .then(function(res) {
      return res.data.data
    })
});

// office
export const OFFICE_LIST = 'OFFICE_LIST';
export const OFFICE_CREATE = 'OFFICE_CREATE';
export const OFFICE_UPDATE = 'OFFICE_UPDATE';

export const officeList = createAction(OFFICE_LIST, () => {
  return axios.get(apiUrl + 'client/offices')
    .then(function(res) {
      return res.data.data
    })
});

export const officeCreate = createAction(OFFICE_CREATE, (data) => {
  return axios.post(apiUrl + 'client/offices', data)
    .then(function(res) {
      return res.data.data
    })
});

export const officeUpdate = createAction(OFFICE_UPDATE, (id, data) => {
  return axios.put(apiUrl + 'client/offices/' + id, data)
    .then(function(res) {
      return res.data.data
    })
});

// Application
export const applications = createAction(APPLICATION_LIST, (data) => {
  return axios.get(apiUrl + 'client/applications', data)
    .then(function(res) {
      return res.data.data.applications
    })
});

export const deleteApplication = createAction(APPLICATION_DELETE, (id) => {
  return axios.delete(apiUrl + 'client/applications/' + id)
    .then(function(res) {
      return res.data.data
    })
});

export const addAppAuthorizedLog = createAction(APP_AUTHORIZED_LOG_CREATE, (data) => {
  return axios.post(apiUrl + 'client/app_authorized_logs', data)
    .then(function(res) {
      return res.data.data
    })
});
